module.exports = __webpack_public_path__ + "static/media/joshua-tree.438a1302.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/small/joshua-tree.png
 ** module id = 196
 ** module chunks = 0
 **/